import { getDerivedValue, patchNodeParams } from '@/api/nodes';
import { analysisStatusActions } from '@/stores/analysisStatusStore';
import { caseActions } from '@/stores/caseStore';
import { nodeActions } from '@/stores/nodeStore';

export const updateNodeParams = async (params, urlParams) => {
  const { caseId, nodeId } = urlParams;
  const { data } = await patchNodeParams(caseId, nodeId, params);
  const { params: updatedParams, balanced, analysis_stale: analysisStale, is_default: isDefault } = data;

  nodeActions.updateParams(updatedParams, isDefault);

  if (balanced) {
    caseActions.markBalanced();
  } else {
    caseActions.markUnbalanced();
  }

  if (analysisStale) {
    analysisStatusActions.clear();
  }

  return updatedParams;
};

export const fetchDerivedValues = async (name, urlParams) => {
  const { caseId, nodeId } = urlParams;
  const data = await getDerivedValue(caseId, nodeId, name);
  return data;
};
